import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description ArrowUp icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { ArrowUp } from '@sravni/design-system-icons'
 *
 * <ArrowUp />
 * ```
 */
var ArrowUp = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "ArrowUp", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m4 13 6-6 6 6", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { ArrowUp };
//# sourceMappingURL=ArrowUp.js.map
